<template>
	<div>
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<div class="paymentbox">
			<v-braintree
				v-if="client_token"
				v-bind:authorization="client_token"
				@success="onSuccess"
				@error="onError"
				@load="onLoad"
				:paypal="{ flow: 'vault' }"
			>
				<template v-slot:button="slotProps" v-if="showPaynow">
					<div class="btn-over">
						<button
							class="btn btn-primary btn-sm my-2 my-sm-0"
							@click="slotProps.submit"
						>
							Pay Now
						</button>
					</div>
				</template>
			</v-braintree>
		</div>
	</div>
</template>

<script>
export default {
	name: "Payment",
	data() {
		return {
			client_token: "",
			showPaynow:false
		};
	},
	created(){
		var Data = {
			token: this.$store.state.user.accessToken,
		};
		this.$store.dispatch("getClientToken", Data).then((res) => {
			if (res) {
				this.$store.commit("setBTClientToken", res.token);
				this.client_token=this.$store.getters.getBTClientToken;
				this.$store.commit(
						"tempUserToken",
						this.$store.state.user.accessToken
					);
			}
		})
		
		this.$store.commit("setLoader", true);
		
	},
	methods: {
		onSuccess(payload) {
			this.$store.commit("setNonceToken", payload.nonce);
			let dataToSend = {};
			dataToSend.nonce = this.$store.state.nonceToken;
			dataToSend.subscriptionId = this.$route.params.sid;
			dataToSend.slug="braintree"
			this.$store.commit("setLoader", true);
			this.$store
				.dispatch("processSubs", dataToSend)
				.then((res) => {
						this.$store.commit("setLoader", false);
								this.$store.commit(
									"setNotification",
									"Subscription Added Sucessfully!! "
								);
								this.$store.commit("setuserLoggedIn", true);
								this.$router.push("/home")
				})
				.catch((err) => {
					this.$store.commit("setLoader", false);
					this.$store.commit("setNotification", " Error Occured Please try again  ");
					//this.$router.push("/login");
				});
		},
		onError(error) {
			let message = error.message;
			this.$store.commit("setNotification", error.message);
			// Whoops, an error has occured while trying to get the nonce
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		onLoad(){
			this.showPaynow=true;
			this.$store.commit("setLoader",false);
		}
	},
};
</script>

<style scoped>
.paymentbox {
	margin: 0 auto;
	max-width: 40%;
	padding-top: 50px;
}
.btn-primary {
	margin-top: 10px;
}
.btn-over {
	margin-top: 15px;
	width: 100%;
	text-align: center;
}
</style>
